<template>
  <div class="supercontainer-finanzas">
    <div class="container-general-finanzas">
      <div class="finanzasBannerOf-container">
        <div class="container-column-finanzas">
          <div>
            <img
              alt="Edificio vectorial con persona"
              class="edificio-finanzas"
              src="@/assets/img/banners/oferta/finanzas/edificio-finanzas.svg"
            />
          </div>
          <div class="finanzasBannerOf-text">
            <h2 class="finanzasBannerOf-title">
              {{ title }}
            </h2>
            <p class="finanzasBannerOf-subtitle">
              {{ subtitle }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "BannerFinanzasMorada",
  props: {
    title: String,
    subtitle: String
  }
};
</script>

<style scoped>
.supercontainer-finanzas {
  margin-top: 50px;
  background-color: #eaf9f4;
}

.container-column-finanzas {
  display: flex;
  align-items: center;
  gap: 64px;
}

.container-general-finanzas {
  min-height: 321px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  max-width: 1281px;
  margin: auto;
  position: relative;
}

.finanzasBannerOf-title {
  font-family: "BentonSansBBVA-Medium", Helvetica, Arial, sans-serif;
  font-size: 36px;
  line-height: 40px;
  color: #121212;
  margin-top: 0;
  margin-bottom: 16px;
}

.finanzasBannerOf-container {
  max-width: 1017.72px;
  margin: auto;
  margin-top: 51px;
}

.finanzasBannerOf-subtitle {
  font-size: 24px;
  line-height: 32px;
  font-weight: 350;
  margin-top: 0px;
  margin-bottom: 0px;
}

@media (max-width: 1270px) {
  .finanzasBannerOf-container {
    max-width: 900px;
  }
}

@media (max-width: 1080px) {
  .finanzasBannerOf-container {
    max-width: 800px;
  }
}

@media (max-width: 850px) and (min-width: 600px) {
  .finanzasBannerOf-title {
    font-size: 28px;
    line-height: 32px;
  }

  p.finanzasBannerOf-subtitle {
    font-size: 20px;
    line-height: 24px;
  }
}

@media (max-width: 600px) {
  .finanzasBannerOf-container {
    margin-top: 34px;
  }

  .finanzasBannerOf-title {
    font-size: 12px;
    line-height: 14px;
    margin-bottom: 0;
  }

  .finanzasBannerOf-subtitle {
    font-size: 8px;
    line-height: 12px;
  }

  .supercontainer-finanzas {
    min-height: 138px;
    max-height: 138px;
    margin-top: 8px;
  }
  .container-general-finanzas {
    min-height: 138px;
    max-height: 138px;
    padding: 0 25px;
  }

  .finanzasBannerOf-container .container-column-finanzas {
    gap: 9px;
  }

  .edificio-finanzas {
    width: 56px;
  }
}
</style>
